import type { Role } from '@/types/user';

export const ROLE_LABEL: Record<Role, string> = {
  PATIENT: 'Paciente',
  DOCTOR: 'Médico',
  MANAGER: 'Gestor',
  SUPPORT: 'Suporte',
  FINANCE: 'Financeiro',
  FRANCHISEE: 'Franqueado',
};

/** Perfis que exigem verificação em duas etapas. */
export const STAFF_ROLES: Role[] = ['DOCTOR', 'MANAGER', 'SUPPORT', 'FINANCE', 'FRANCHISEE'];

/** Área inicial de cada perfil (usada após o login e no seletor de áreas). */
export const ROLE_HOME: Record<Role, string> = {
  PATIENT: '/inicio',
  DOCTOR: '/medico',
  MANAGER: '/gestor',
  SUPPORT: '/suporte',
  FINANCE: '/financeiro',
  FRANCHISEE: '/franqueado',
};
